/**
 * AskConciergePill — P4 · founder ear-test 6 Jun 2026 evening
 *
 * The client-facing pill on each dossier venue. When the client
 * holding the dossier wants to ask a sticky question
 * ("can Daigo do a private room for fourteen?"), this pill is the
 * one-tap surface. The Concierge® mark on it means whatever holds
 * behind it MUST hold the no-fabrication line.
 *
 * ROUTING (founder constraint Q2-ii, 6 Jun 2026 evening):
 *
 *   DEFAULT (safe · no flip needed)
 *     → routes to the founder's verified WhatsApp number with a
 *       pre-filled message naming the venue. A human concierge
 *       handles the question. ZERO risk of AI fabrication behind
 *       the mark.
 *
 *   MIRA WIRED, DARK BY DEFAULT
 *     → when `REACT_APP_P4_MIRA_LIVE === "true"` (set in
 *       frontend/.env), the pill routes to Mira (Chatbase iframe
 *       carried by /mira on this site, with the venue context in
 *       the query string).
 *     → flipped ONLY after the founder has personally tested Mira's
 *       behaviour behind the Concierge® mark and confirmed she
 *       holds the no-fabrication line.
 *
 * SURFACE:
 *   - SHOWS on the client-facing dossier (DraftView in /table/curate
 *     after the draft renders · plus the JSON output for the web
 *     collection).
 *   - DOES NOT show on the slate (the founder is the concierge at
 *     the slate stage).
 */
import React from "react";
import {
    buildAskConciergeTarget,
} from "./ask-concierge-helpers";


export function AskConciergePill({
    venue,
    draftId,
    // Optional override of the Mira target (kept here so a future
    // rebuild to /mira owns its own URL without touching this file)
    miraHref,
    testIdPrefix = "ask-concierge",
}) {
    if (!venue) return null;
    const venueName = venue.name || "this venue";
    const venueCity = venue.city || venue.locality || null;

    const target = buildAskConciergeTarget({
        venueName, venueCity, draftId, miraHref,
    });

    return (
        <a
            href={target.href}
            target={target.miraLive ? "_self" : "_blank"}
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            data-testid={`${testIdPrefix}-pill`}
            data-mira-live={target.miraLive ? "true" : "false"}
            className="t-mono uppercase"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 10,
                letterSpacing: "0.16em",
                color: "var(--t-paper2)",
                background: "var(--t-ink)",
                borderRadius: 999,
                padding: "6px 13px",
                fontWeight: 700,
                textDecoration: "none",
                whiteSpace: "nowrap",
                marginTop: 8,
            }}
        >
            <span aria-hidden="true">·</span>
            {target.label}
        </a>
    );
}


export default AskConciergePill;
